import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router'
import { CurrentCompanyContext } from '../../App.js'
import { useMutation } from 'react-query'
import { useNotifications } from '../shared/Notifications.js'
import { useMutationClient } from '../shared/hooks.js'
import { Container } from '../layout/AppLayout.js';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';

import Header from "../shared/Header.js"
import { CurrentUserContext } from '../../App.js';
import { isAllowed } from '../shared/FeatureChecker.js';
import NotificationForm from "./NotificationForm.js"

export default function NewNotificationPage() {
  const navigate = useNavigate()
  const mutationClient = useMutationClient()
  const currentCompany = useContext(CurrentCompanyContext)
  const notifications = useNotifications()
  const currentUser = useContext(CurrentUserContext)

  useEffect(() => {
  if(currentUser){
      const allowed= isAllowed({user: currentUser,feature: "CREATE_NOTIFICATION"})
      if (!allowed){
        navigate('/error?error=403')
      }
    }

  },[currentUser])

  const createNotification = useMutation(
    data => mutationClient.post(`notifications`, { ...data, company_id: currentCompany && currentCompany.id }), {
    onSuccess: (data, variables, context) => {
      if( data.status === 204 ){
        notifications.success('Notificación creada correctamente')
        navigate(`/notifications`)
      }
    },
    onError: () => {
      notifications.danger('Ha ocurrido un error al crear la notificación')
    }
  })

  return (
    <Container>
      <Row>
        <Header title="Crear notificación" items={[
          { label: `Listado de notificaciones`, to:"/notifications"},
          { label: `Crear notificación` },
        ]} />
      </Row>

      <Row className="mb-3">
        <div className="col-12 col-lg-6">
          <Card className="mb-2 shadow-sm">
            <Card.Header>
              <span>Nueva notificación</span>
            </Card.Header>
            <Card.Body>
              <NotificationForm
                save={data => createNotification.mutate(data)}
                isLoading={createNotification.isLoading}
              />
              
            </Card.Body>
          </Card>
        </div>
      </Row>
    </Container>
  )
}
